import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import axios from 'axios'
import lodash from 'lodash'
import moment from 'moment'
import { mixs } from '@/mixins'
import Toast from 'vue-toastification'
import * as VueGoogleMaps from 'vue2-google-maps'
import * as Sentry from '@sentry/vue'
import 'vue-toastification/dist/index.css'
import "vue-gifplayer/src/gif.css"

Vue.config.productionTip = false

// import of mixins for the alert call
Vue.mixin(mixs);

// use of alerts throughout the project
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true
});

// window.FORMAT_MONEY = function (n, dp, ds, ts) {
//   dp = isNaN(dp = Math.abs(dp)) ? 2 : dp,
//     ds = typeof ds === "undefined" ? "." : ds;
//   ts = typeof ts === "undefined" ? "," : ts;
//   var sign = n < 0 ? "-" : "";
//   var i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(dp)));
//   var j = (j = i.length) > 3 ? j % 3 : 0;

//   return sign +
//     (j ? i.substr(0, j) + ts : "") +
//     i.substr(j).replace(/(\ds{3})(?=\ds)/g, "$1" + ts) +
//     (dp ? ds + Math.abs(n - i).toFixed(dp).slice(2) : "");
// }

window.FORMAT_MONEY = function (n) {
  let nf = Number(n).toFixed(2);
  return nf.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


// import axios
window.DB = axios;

// initailize URI for global use
//qa --- dev --- alfa---api.proplat.com
// window.URI = 'http://localhost:3000/dev'
// window.URI = 'https://api.proplat.com/alfa'
// window.URI = 'https://api.proplat.com/alfa'
window.URI = 'https://api.fresherpay.com/alfa'

//window.URI = 'https://api.proplat.com/alfa'
window.URIVendors = "https://alfa.vendors.proplat.com/";


window.lodash = lodash

window.MOMENT = moment;

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyArzew42XOo4jWF_0fWBPa-lEhpFn6-OS0',
//     // key: 'AIzaSyAKC6VvI7gKOK5mKruoRxmhz-nWb7AFu6w',
//     libraries: 'places',
//   }
// });

Vue.use(VueGoogleMaps, { load: { key: 'AIzaSyArzew42XOo4jWF_0fWBPa-lEhpFn6-OS0', libraries: 'places' } })

function sanitizeSentryEvent(event) {
  if (event.user) {
    delete event.user.email
    delete event.user.username
    delete event.user.ip_address
  }

  if (event.request && event.request.headers) {
    delete event.request.headers.Authorization
    delete event.request.headers.authorization
    delete event.request.headers.cookie
    delete event.request.headers.Cookie
  }

  if (event.request && event.request.url) {
    event.request.url = removeSensitiveQueryParams(event.request.url)
  }

  return event
}

function removeSensitiveQueryParams(url) {
  const sensitiveParams = [
    'token',
    'access_token',
    'refresh_token',
    'authorization',
    'signature',
    'signedUrl',
    'X-Amz-Signature',
    'X-Amz-Credential',
    'X-Amz-Security-Token'
  ]

  try {
    const parsedUrl = new URL(url)

    sensitiveParams.forEach((param) => {
      parsedUrl.searchParams.delete(param)
    })

    return parsedUrl.toString()
  } catch {
    return url
  }
}

Sentry.init({
  Vue,
  dsn: 'https://90bfdc726d8c2863184365ea1a698f64@o4511231035179008.ingest.us.sentry.io/4511231748997120',
  sendDefaultPii: false,
  beforeSend(event) {
    console.log('SENTRY BEFORE:', JSON.parse(JSON.stringify(event)))
    const sanitized = sanitizeSentryEvent(event)
    console.log('SENTRY AFTER:', JSON.parse(JSON.stringify(sanitized)))
    return sanitized
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
